import { Button } from "bootstrap";
import React, { useEffect, useState, useRef } from "react";
import ReactToPrint from "react-to-print";
import { useParams } from "react-router-dom";
import CustomIcons from "../../../components/icons/kIcons.component";
import TextField from "../../../components/inputs/textfield";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import CustomTable from "../../../components/table/table";
import {
  admin_applications_view,
  admin_app_submit,
  admin_status,
  area_allocate_submit,
} from "../admin.api";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import "./view.css";
import moment from "moment";
import AllocateAreaForm from "./Form/form";
import jwtDecode from "jwt-decode";

export default function View(props) {
  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const [appdata, setAppdata] = useState({});
  const [adminStatus, setadminStatus] = useState({});
  const [printMode, setPrintMode] = useState(false);
  const [count, setCount] = useState(1);
  const [showModal, setShowModal] = useState(false);

  const [status, setStatus] = useState([
    {
      id: 1,
      status_title: "Submit for Acceptance",
      status_code: "1",
    },
    {
      id: 5,
      status_title: "Revert with Message",
      status_code: "5",
    },
    // {
    //   id: 3,
    //   status_title: "Reject with Reason",
    //   status_code: "2",
    // },
  ]);
  const [snackMessage, setSnackMessage] = useState("");
  const [statusLabel, setstatusLabel] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [formData, setFormData] = useState({});
  const [isActive, setIsActive] = useState(true);
  const [snackOpen, setSnackOpen] = useState(false);

  const { id } = useParams();
  const { id2 } = useParams();
  const [open, setOpen] = useState(false);
  const onSearch = () => {
    //
  };
  const getApplication = () => {
    setIsActive(true);
    admin_applications_view(id)
      .then((res) => {
        setAppdata(res.data);
        setIsActive(false);
        setstatusLabel(res.applicattion_status_label);
      })
      .catch((err) => {
        setIsSnackError(true);
        setIsActive(false);
        setSnackOpen(true);
        setSnackMessage(err.response.data.message);
      });
  };

  useEffect(() => {
    getApplication();
  }, []);
  const handleFormSubmit = (updatedData) => {
    const item = updatedData?.[0] || {};
    // Simple presence validation: Proposed Area and Load Factor must be entered
    if (!item?.allotted_space || !item?.load_factor) {
      setSnackMessage(
        !item?.allotted_space && !item?.load_factor
          ? "Please enter Proposed Area and Load Factor"
          : !item?.allotted_space
            ? "Please enter Proposed Area"
            : "Please enter Load Factor"
      );
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }
    const defaultLeaseYear =
      parseFloat(appdata?.capital_investment || 0) > 99 ? 90 : 30;

    const payload = {
      area_managememt_sub_tables_id: item?.area_managememt_sub_tables_id || "",
      allotted_space: item?.allotted_space || "",
      load_factor: item?.load_factor || "",
      total_area: item?.total_area || "",
      total_amount: item?.total_amount || "",
      years: item?.years || defaultLeaseYear,
      application_id: appdata?.id || "",
      user_id: appdata?.user_id || "",
    };

    console.log("Payload being sent:", payload);

    setIsActive(true);

    area_allocate_submit(payload)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((err) => {
        setSnackMessage(err.response?.data?.message || "An error occurred");
        setIsSnackError(true);
        setIsActive(false);
        setSnackOpen(true);
      });
  };

  const formProps = {
    formvalues: [],
    data: [],
    formData: {},
    initialFormData: {},
    handleFormData: (updatedData) => {
      console.log("Form data:", updatedData);
      setFormData(updatedData);
    },
    handleFormSubmit,
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push(-1);
    }
  };
  const handleChange = (e) => {
    setadminStatus({ ...adminStatus, [e.target.name]: e.target.value });
    setCount(count + 1);
    console.log(adminStatus);
  };
  const handleFileChange = (e) => {
    let size = e.target.files[0].size;
    let type = e.target.files[0].name.split(".").pop();

    let mb = size / Math.pow(1024, 2);

    if (mb < 1) {
      setadminStatus({
        ...adminStatus,
        file_name: e.target.files[0].name,
        [e.target.name]: e.target.files[0],
      });
    } else {
      setSnackMessage("File size is greater than 1MB");
      setIsSnackError(true);
      setSnackOpen(true);
      setadminStatus({
        ...adminStatus,
        file_name: e.target.files[0].name,
        [e.target.name]: e.target.files[0],
      });
    }
  };
  const handleAdminStatusUpdate = (e) => {
    e.preventDefault();

    let size = adminStatus?.sample_file?.size || 0;
    let mb = size / Math.pow(1024, 2) || 0;
    if (mb < 1) {
      const form = new FormData();

      form.append("file_name", adminStatus.file_name ?? null);
      form.append("status_id", adminStatus.status_id ?? null);
      form.append("sample_file", adminStatus.sample_file ?? "");
      if (adminStatus.status_id == 1) {
        form.append("admin_message", adminStatus.message ?? null);
      } else if (adminStatus.status_id == 5) {
        form.append("user_message", adminStatus.message ?? null);
      }

      form.append("application_id", appdata.id ?? null);

      setIsActive(true);
      admin_app_submit(form)
        .then((res) => {
          setSnackMessage(res.message);
          setIsSnackError(false);
          setSnackOpen(true);
          setIsActive(false);
        })
        .catch((err) => {
          setSnackMessage(err.response.data.message);
          setIsSnackError(true);
          setIsActive(false);
          setSnackOpen(true);
        });
    } else {
      setSnackMessage("File size is greater than 1MB");
      setIsSnackError(true);
      setSnackOpen(true);
    }
  };

  const handlePrint = () => {
    var originalContents = document.body.innerHTML;
    var printReport = document.getElementById("printable-area").innerHTML;
    document.body.innerHTML = printReport;
    window.print();
    document.body.innerHTML = originalContents;
  };

  const handleDownloadProposal = () => {
    let path = `${result}${appdata.upload_proposal}`;
    window.open(path, "_blank");
  };
  const componentRef = useRef();
  console.log(appdata);
  // const handleDownload = (item) => {
  //   if (!item?.logo) {
  //     alert("No logo available to download.");
  //     return;
  //   }

  //   // Construct the full URL of the logo
  //   let logoPath = `${result}/${item.logo}`; // Ensure `result` contains the base URL

  //   // Create an anchor element dynamically
  //   const link = document.createElement("a");
  //   link.href = logoPath;
  //   link.setAttribute("download", item.logo.split("/").pop()); // Extracts the filename
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const handleDownload = () => {
    let path = `${result}${appdata.logo}`;
    window.open(path, "_blank");
  };

  const handleDownloadProposalOwn = () => {
    let path = `${result}${appdata.area_management[0]?.proposal_file}`;
    window.open(path, "_blank");
  };
  const flattenedAllocations = appdata.area_allocations?.map((item) => ({
    ...item,
    location: item.area_sub_table?.location?.locations ?? "",
    sub_location: item.area_sub_table?.sub_location ?? "",
    built_space_type_name: item.area_sub_table?.built_space_type?.name ?? "",
    category: item.area_sub_table?.built_space_type ? "Built-up Space" : "Land",
  }));

  return (
    <div>
      <Loader open={isActive} />
      <div className="view-container">
        <div className="col-12 d-flex justify-content-end">
          <ReactToPrint
            onBeforePrint={() => setPrintMode(true)}
            onAfterPrint={() => setPrintMode(false)}
            trigger={() => (
              <button
                type="button"
                className="btn btn-warning1 btn-sm mr-2 mb-2 dwnld"
              >
                <CustomIcons iconName="download" iconClass="down" />
                Download info
              </button>
            )}
            content={() => componentRef.current}
          />
          <button
            type="button"
            onClick={(e) => handleDownloadProposal()}
            className="btn btn-success ml-2 btn-sm mb-2 "
          >
            <CustomIcons iconName="download" iconClass="down" />
            Download Proposal
          </button>
        </div>
        <form onSubmit={handleAdminStatusUpdate}>
          <div ref={componentRef} className={printMode ? "p-2" : "p-4"}>
            <div className="d-flex justify-content-between">
              <h6>
                <b>New Company Request</b>
              </h6>
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => {
                  id2 == "kspace"
                    ? props.history.push("/company-request-list/kspace")
                    : props.history.push("/company-request-list/own");
                }}
              >
                Back
              </button>
            </div>
            <hr />

            <div className="data">
              <div className="row">
                <div className="col-3">Company Name</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.company_name ?? ""}</div>
              </div>
              <div className="row">
                <div className="col-3">Application ID</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {appdata.unique_application_ref_no ?? ""}
                </div>
              </div>
              <div className="row">
                <div className="col-3">Contact Person Name</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.person_name ?? ""}</div>
              </div>
              <div className="row">
                <div className="col-3">Contact Person Designation</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.person_designation}</div>
              </div>
              <div className="row">
                <div className="col-3">Primary Mail Id</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.email ?? ""}</div>
              </div>
              <div className="row">
                <div className="col-3">Primary Contact No</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.phone_no ?? ""}</div>
              </div>
              {appdata.site_link && (
                <div className="row">
                  <div className="col-3">Website Link</div>
                  <div className="col-1">:</div>
                  <div className="col-7">{appdata.site_link ?? ""}</div>
                </div>
              )}
              {appdata.logo && (
                <div className="row">
                  <div className="col-3">Company Logo</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    {/* <a
                  style={{ cursor: "pointer" }}
                  onClick={(e) => handleDownload(appdata)}
                >
                  <b>Download Logo</b>
                </a> */}
                    <button
                      type="button"
                      onClick={(e) => handleDownload(appdata)}
                      className="btn btn-reject btn-dark btn-sm"
                    >
                      Download Logo
                    </button>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-3">Address</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.address ?? ""}</div>
              </div>
              {appdata.alternate_email && (
                <div className="row">
                  <div className="col-3">Alternate Mail Id</div>
                  <div className="col-1">:</div>
                  <div className="col-7">{appdata.alternate_email ?? ""}</div>
                </div>
              )}
              {appdata.alternate_phone && appdata.country_code && (
                <div className="row">
                  <div className="col-3">Alternate Contact No</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    {appdata.alternate_phone && (
                      <>
                        {appdata.country_code &&
                          appdata.country_code !== "" &&
                          appdata.country_code !== "undefined" &&
                          appdata.country_code !== "null" && (
                            <>
                              {appdata.country_code ?? ""}{" "}
                              {appdata.country_code &&
                                appdata.country_code !== ""
                                ? "-"
                                : ""}{" "}
                            </>
                          )}
                      </>
                    )}
                    {appdata.alternate_phone ?? ""}
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-3">New company / Existing company ?</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {" "}
                  {appdata.company_status === "new_company"
                    ? "New Company"
                    : appdata.company_status === "existing_company"
                      ? "Existing Company"
                      : ""}
                </div>
              </div>
              {appdata?.financial_records?.length > 0 && (
                <>
                  <div className="row mt-3">
                    <div className="col-12">
                      <h6 className="mb-0"><b>Financial Records</b></h6>
                    </div>
                  </div>
                  <hr />
                  <div className="data">
                    <div className="row">
                      <div className="col-12">
                        <CustomTable
                          className="areatable"
                          {...props}
                          columns={[
                            { title: "Financial Year", field: "financial_year" },
                            { title: "FY Turnover", field: "fy_turnover" },
                            // { title: "Remarks", field: "remarks" },
                          ]}
                          data={appdata.financial_records}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div className="row">
                <div className="col-3">
                  Capital Investment Expected in Crores
                </div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.capital_investment ?? ""}</div>
              </div>
              <div className="row">
                <div className="col-3">Initial Direct Employment</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.ex_man_power ?? ""}</div>
              </div>
              <div className="row">
                <div className="col-3">Abstract Project Proposal</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {appdata.abstract_project_proposal ?? ""}
                </div>
              </div>
              <div className="row">
                <div className="col-3">Product Profile</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {appdata?.product_profiles?.map((item, i) => (
                    <div key={i}>
                      <div className="col-12 mb-1">
                        <b>{item.product_name ?? ""}</b>
                      </div>
                      <div className="col-12 mb-2 ">
                        <div>{ReactHtmlParser(item.product_desc)}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="row">
                <div className="col-3">Domain Type</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {appdata?.domain_types?.map((dom, i) => (
                    <div key={i}>{dom.domain_name}</div>
                  ))}
                  {(appdata?.any_other_flag == 1 ||
                    (appdata?.any_other_domain &&
                      appdata?.any_other_domain != null)) && (
                      <div>{appdata?.any_other_domain}</div>
                    )}

                  <></>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-3">Any Other Domain</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.any_other_domain ?? ""}</div>
              </div> */}

              {/* <div className="row">
                <div className="col-3">Document Uploaded</div>
                <div className="col-1">:</div>
                <div className="col-7 ">{appdata?.file_name}</div>
              </div> */}
            </div>
            {appdata?.upload_proposal && (
              <div className="data">
                <div className="row mt-3">
                  <div className="col-3">Project Proposal</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={(e) => handleDownloadProposal()}

                    >
                      Download Proposal
                    </button>
                  </div>
                </div>
              </div>
            )}

            {appdata.area_type && (
              <h6>
                <b>Area Requirements</b>
              </h6>
            )}
            <hr />
            <div className="data">
              {appdata.area_type === "built_up_space" && (
                <div className="row">
                  <div className="col-3">
                    Requested <br></br> Built-up space on Rent per Month
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Preference No", field: "id", type: "dynId" },
                        { title: "Location", field: "location" },
                        { title: "Sub Location", field: "sub_location" },
                        {
                          title: "Category",
                          field: "area_type",
                          render: (rowData) =>
                            rowData.area_type === "built_up_space"
                              ? "Built-up Space"
                              : "Land",
                        },
                        {
                          title: "Built-Up Space Category",
                          field: "built_space_type",
                        },
                        {
                          title: "Rentable Area(in sqft)",
                          field: "available_area",
                        },
                        {
                          title: "Area Requirement (Requested area in sqft)",
                          field: "area_in_sqft",
                        },

                        // {
                        //   title: "Investment model",
                        //   field: "investment_model",
                        // },
                        // { title: "Management plan", field: "management_plan" },
                      ]}
                      data={appdata?.area_management}
                    />
                  </div>
                </div>
              )}
              {appdata.area_type === "equipped_facility" && (
                <div className="row">
                  <div className="col-3">Equipped Facility per Month </div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Preference No", field: "id", type: "dynId" },
                        { title: "Location", field: "location" },

                        {
                          title: "Requested Area Requirement",
                          field: "area_in_sqft",
                        },
                        {
                          title: "Rentable Area(in sqft)",
                          field: "available_area",
                        },
                      ]}
                      data={appdata?.area_management}
                    />
                  </div>
                </div>
              )}
              {appdata.area_type === "land_on" && (
                <div className="row">
                  <div className="col-3">Requested Land on Lease</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Preference No", field: "id", type: "dynId" },
                        { title: "Location", field: "location" },
                        { title: "Sub Location", field: "sub_location" },
                        {
                          title: "Category",
                          field: "area_type",
                          render: (rowData) =>
                            rowData.area_type === "built_up_space"
                              ? "Built-up Space"
                              : "Land On Lease",
                        },
                        {
                          title: "Land Requirement(in cents)",
                          field: "area_in_acres",
                        },
                        // { title: "Address", field: "land_address" },

                        { title: "Lease Years", field: "lease_year" },
                        {
                          title: "Rentable Area",
                          field: "available_area",
                        },
                      ]}
                      data={appdata?.area_management}
                    />
                  </div>
                </div>
              )}
              {appdata.area_type === "joint_venture" && (
                <div className="row">
                  <div className="col-3">
                    Requested <br></br>Joint Venture
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7 venure">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Preference No", field: "id", type: "dynId" },
                        { title: "Location", field: "location" },
                        { title: "Sub Location", field: "sub_location" },
                        {
                          title: "Category",
                          field: "area_management_id",
                          render: (rowData) =>
                            rowData.area_management_id == 1
                              ? "Built-up Space"
                              : "Land",
                        },
                        {
                          title: "Area Type",
                          field: "built_space_type",
                        },
                        {
                          title: "Request Area",
                          render: (rowData) =>
                            rowData.area_management_id == 1
                              ? `${rowData.area_in_sqft ?? 0} Sq.ft`
                              : `${rowData.area_in_acres ?? 0} Cents`,
                        },
                        { title: "Lease Years", field: "lease_year" },
                        {
                          title: "Investment Model",
                          field: "investment_model",
                        },
                        { title: "Management Plan", field: "management_plan" },
                      ]}
                      data={appdata?.area_management}
                    />
                  </div>
                </div>
              )}
              {appdata.area_type === "own_land" && (
                <div className="row">
                  <div className="col-3">
                    Requested <br></br>Own Premises{" "}
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Location", field: "location" },
                        { title: "Available Area", field: "area_in_sqft" },
                        { title: "Survey Number", field: "survey_no" },
                        { title: "Block Number", field: "block_no" },
                        { title: "Village Name", field: "village_name" },
                        // { title: "Available Area", field: "area" },
                        {
                          title: "Nature Of Holding",
                          field: "nature_of_holding",
                        },
                      ]}
                      data={appdata?.area_management}
                    />
                  </div>
                </div>
              )}
              {appdata.proposal_file != null &&
                appdata.area_type === "own_land" && (
                  <div className="row">
                    <div className="col-3">
                      Interested in Joint venture with KSPACE
                    </div>
                    <div className="col-1">:</div>
                    <div className="col-7">
                      {/* <a
                  style={{ cursor: "pointer" }}
                  onClick={(e) => handleDownload(appdata)}
                >
                  <b>Download Logo</b>
                </a> */}
                      <button
                        type="button"
                        onClick={(e) => handleDownloadProposalOwn(appdata)}
                        className="btn btn-reject btn-dark btn-sm"
                      >
                        Download Proposal
                      </button>
                    </div>
                  </div>
                )}
              {appdata.area_type !== "own_land" &&
                appdata.area_type !== "joint_venture" && (
                  <>
                    {/* {(appdata.application_status === 0 ||
                      appdata.application_status === 3) && ( */}
                    <div className="row mt-3">
                      <div className="col-3">Allocate</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => setShowModal(true)}
                        >
                          Click here
                        </button>
                      </div>
                    </div>
                    {/* )} */}
                  </>
                )}

              {appdata.area_type !== "own_land" && (
                <>
                  {appdata.area_allocations &&
                    (appdata.area_allocations.length > 0 &&
                      <div className="row mt-3">
                        <div className="col-3">Allotted</div>
                        <div className="col-1">:</div>
                        <div className="col-7">
                          <CustomTable
                            className="areatable"
                            {...props}
                            columns={[
                              {
                                title: "Location",
                                field: "location",
                              },
                              {
                                title: "Sub Location",
                                field: "sub_location",
                              },
                              {
                                title: "Category",
                                field: "category",
                              },
                              ...(flattenedAllocations.some(
                                (row) => row.category === "Built-up Space"
                              )
                                ? [
                                  {
                                    title: "Built-Up Space Category",
                                    field: "built_space_type_name",
                                  },
                                ]
                                : []),
                              ...(flattenedAllocations.some(
                                (row) => row.category === "Land"
                              )
                                ? [
                                  {
                                    title: "Lease Years",
                                    field: "years",
                                  },
                                ]
                                : []),
                              {
                                title: "Load Factor",
                                field: "load_factor",
                              },
                              {
                                title: "Area Allotted",
                                field: "allotted_space",
                              },
                              {
                                title: "Total Rent (Rupees/month)",
                                field: "total_amount",
                              },

                            ]}
                            data={flattenedAllocations}
                          />
                        </div>
                      </div>
                    )}
                </>
              )}
              <div className="nio row">
                <div className="d-flex ">
                  <div className="col-3 ">Current Application Status</div>
                  <div className="col-1">:</div>
                  <div className="col-7 blink_me1">
                    {appdata?.application_status == 0
                      ? "Pending"
                      : appdata?.application_status == 1
                        ? "Submitted for acceptance"
                        : appdata?.application_status == 2
                          ? "Accepted"
                          : appdata?.application_status == 3
                            ? "Super Admin Reverted"
                            : appdata?.application_status == 4
                              ? "Rejected"
                              : appdata?.application_status == 7
                                ? "Ongoing Project"
                                : appdata?.application_status == 5
                                  ? "Admin Reverted"
                                  : "Agreement Execution"}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-3">Created At</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {appdata.created_at
                    ? moment(appdata.created_at).format("DD-MM-YYYY")
                    : ""}
                </div>
              </div>
              {appdata?.to_super_admin_message_content &&
                appdata?.to_super_admin_message_content !== "" && (
                  <div className="row">
                    <div className="col-3">Message from Super Admin</div>
                    <div className="col-1">:</div>
                    <div className="col-7 ">
                      {appdata?.to_super_admin_message_content}
                    </div>
                  </div>
                )}
            </div>
          </div>
          {(appdata.application_status === 0 ||
            appdata.application_status === 3) &&
            adminType !== 23 && (
              <div className="px-4">
                {status?.length !== 0 && (
                  <>
                    <div className="col-6 mt-3 status">
                      <label>
                        <b>Select Action</b>
                      </label>
                      <select
                        className="form-select mt-2"
                        aria-label="Default select example"
                        onChange={handleChange}
                        name="status_id"
                        required
                        value={adminStatus.status_id}
                      >
                        <option value="">Select Action</option>
                        {status?.map((item, i) => (
                          <>
                            {!item.hidden && (
                              <option value={item.id} key={i}>
                                {item.status_title}
                              </option>
                            )}
                          </>
                        ))}
                      </select>
                    </div>

                    {(appdata.application_status === 0 ||
                      appdata.application_status === 3) && (
                        <div className="col-6 mt-3">
                          <div className="form-group">
                            {/* <label for="exampleFormControlTextarea1">Example textarea</label> */}
                            <textarea
                              className="form-control"
                              id="exampleFormControlTextarea1"
                              placeholder="Message.."
                              rows="3"
                              required={
                                adminStatus.sample_file === null ||
                                  adminStatus.sample_file === undefined ||
                                  adminStatus.sample_file === ""
                                  ? true
                                  : false
                              }
                              onChange={handleChange}
                              name="message"
                              value={adminStatus.message}
                            ></textarea>
                          </div>
                        </div>
                      )}
                    {(appdata.application_status === 0 ||
                      appdata.application_status === 3) && (
                        <div className="col-6 mb-01 mt-3">
                          {adminStatus.status_id == 5 && (
                            <>
                              <TextField
                                name="file_name"
                                type="file"
                                required={
                                  adminStatus.message === null ||
                                    adminStatus.message === undefined ||
                                    adminStatus.message === ""
                                    ? false
                                    : false
                                }
                                variant="outlined"
                                onChange={handleFileChange}
                              // accept=".pdf,.doc"
                              />
                              <small className="indicator">
                                Size should be less than 1MB
                              </small>
                            </>
                          )}
                          {/* <Button className="btn btn-danger">Clear File</Button> */}
                        </div>
                      )}
                  </>
                )}

                {status?.length !== 0 && (
                  <button type="submit" className="btn mb-2 mysubbtn">
                    Submit
                  </button>
                )}
              </div>
            )}
        </form>
      </div>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      {showModal && (
        <div className="modal-custom-overlay">
          <div className="modal-custom-container">
            <div className="modal-custom-header">
              <h5>Allocate Area</h5>
              <button
                type="button"
                className="modal-custom-close"
                onClick={() => setShowModal(false)}
              >
                ×
              </button>
            </div>
            <div className="modal-custom-content">
              <AllocateAreaForm
                {...formProps}
                appdata={appdata}
                setAppdata={setAppdata}
                onSubmit={handleFormSubmit} // pass submit handler here
                formId="allocateAreaForm"
              />
            </div>
            <div className="modal-custom-footer">
              <button
                type="button"
                className="btn-custom-secondary"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
              <button
                type="submit" // Change to submit type
                className="btn-custom-primary"
                form="allocateAreaForm"
                onClick={() => {
                  handleFormSubmit(formData); // manually pass current state
                  setShowModal(false); // close modal
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
